module.exports = __webpack_public_path__ + "static/header-img-42ce409cf8940af2e661c3cc9efd2bb9.png";